module.exports = __webpack_public_path__ + "img/volcan.e468446d.jpg";